const properties = {
  store: null,
};

export function getStore() {
  if (!properties.store) {
    throw new Error('store not defined. Has you called setStore?');
  }
  return properties.store;
}

export function setStore(store) {
  properties.store = store;
}

export function getState() {
  return getStore().getState();
}

export function dispatch(action) {
  return getStore().dispatch(action);
}
